import { render } from "./CookiesCheckBox.vue?vue&type=template&id=1894f3c7&scoped=true"
import script from "./CookiesCheckBox.vue?vue&type=script&lang=js"
export * from "./CookiesCheckBox.vue?vue&type=script&lang=js"

import "./CookiesCheckBox.vue?vue&type=style&index=0&id=1894f3c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1894f3c7"]])

export default __exports__